import React from 'react';
import { Box, Button, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { IFilterHeader } from './types';

const useStyles = makeStyles((theme) => ({
    menuHeader: {
        borderBottom: `1px solid ${theme.palette.divider}`,
        paddingBottom: theme.spacing(1),
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    buttonSelectAll: {
        textTransform: 'capitalize',
    },
    title: {
        textTransform: 'capitalize',
    },
}));

export const FilterHeader = ({
    handleSelectAll,
    title,
    singleItem,
    ...props
}: IFilterHeader) => {
    const classes = useStyles();
    const { t } = useTranslation();

    return (
        <Box className={classes.menuHeader} {...props}>
            <Typography variant="h4" className={classes.title}>
                {title}
            </Typography>
            {handleSelectAll && !singleItem && (
                <Button
                    variant="outlined"
                    color="secondary"
                    size="small"
                    onClick={handleSelectAll}
                    className={classes.buttonSelectAll}
                >
                    {t('Buttons.SelectAll')}
                </Button>
            )}
        </Box>
    );
};
